import Bowser from 'bowser';

const generateDisabledButtonOverlay = (buttonProps) => {
  const { left, top, height, width, className, innerHTML } = buttonProps;
  const buttonOverlay = `
  <button
    class="${className}"
    name="button-overlay"
    style="width:${width}px;height:${height}px;left:${left}px;top:${top}px;background-color:transparent;margin:0;border:none;box-shadow:none;color:transparent;opacity:0;position:absolute;z-index:999999999999;"
  >
    ${innerHTML}
  </button>`;

  document.body.insertAdjacentHTML('beforeend', buttonOverlay);
};

const mutationObserver = new MutationObserver((mutations) => {
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].attributeName === 'disabled') {
      removeOverlays();
      overlayDisabledButtons();
      break;
    }
  }
});

const removeOverlays = () => {
  const buttonOverlays = document.getElementsByName('button-overlay');

  Array.prototype.forEach.call(buttonOverlays, (buttonOverlay) => {
    buttonOverlay.parentNode.removeChild(buttonOverlay);
  });
};

const overlayDisabledButtons = () => {
  const { browser } = Bowser.parse(navigator.userAgent);

  if (browser.name === 'Safari') {
    const buttons = document.getElementsByTagName('button');
    const disabledButtons = Array.prototype.filter.call(
      buttons,
      button => button.disabled
    );

    disabledButtons.forEach((disabledButton) => {
      mutationObserver.observe(disabledButton, {
        attributes: true,
      });

      const { x, y, height, width } = disabledButton.getBoundingClientRect();
      const buttonProps = {
        left: x + window.scrollX,
        top: y + window.scrollY,
        height,
        width,
        className: disabledButton.className,
        innerHTML: disabledButton.innerHTML,
      };

      generateDisabledButtonOverlay(buttonProps);
    });
  }
};

const removeButtonOverlays = () => {
  const { browser } = Bowser.parse(navigator.userAgent);

  if (browser.name === 'Safari') {
    mutationObserver.disconnect();
    removeOverlays();
  }
};

export { overlayDisabledButtons, removeButtonOverlays };
